import React, { Component } from "react";
// import { Link } from 'react-router-dom'
import { connect } from "react-redux";
import "./styles.css";
import { QUESTION_TYPES } from "../../config/constants";
import moment from "moment";

class QuestionnaireList extends Component {
  renderAnswer = (type, answer) => {
    let images = [];
    let audioFiles = [];
    if (typeof answer === "object" && answer !== null) {
      images = answer.photos || [];
      audioFiles = answer.audioFiles || [];
      answer = answer.answers;
    }

    switch (type) {
      case QUESTION_TYPES.RATING:
        return (
          <div className="q-rating">
            <div className="lotus">
              <span className="num">{answer}</span>
            </div>
          </div>
        );

      case QUESTION_TYPES.YESNO:
        return (
          <div className="q-answer">
            <p className="answer">{answer ? "Да" : "Не"}</p>
          </div>
        );

      case QUESTION_TYPES.ANSWER:
        return (
          <React.Fragment>
 {answer && Object.values(answer).map(value =>
 <p>{value}</p> 
  )}           
            
            {!!audioFiles.length && (
              <div className="audio-list">
                {audioFiles.map(audio => (
                  <audio
                    key={audio.id}
                    src={audio.location}
                    controls="controls"
                  />
                ))}
              </div>
            )}
            <div className="q-imgs">
              {images.map((image, index) => (
                <div key={image.key + index}>
                  <img src={image.location} alt="Снимка" />
                </div>
              ))}
            </div>
          </React.Fragment>
        );
      default:
        break;
    }
  };

  render() {
    const { dayEntries } = this.props;

    return (
      <div className="questionnaire-list">
        {Object.keys(dayEntries)
          .sort((a, b) => {
            if (moment(a) > moment(b)) {
              return this.props.sortBy === "descend" ? -1 : 1;
            } else {
              return this.props.sortBy === "descend" ? 1 : -1;
            }
          })
          .map(key => {
            return (
              <React.Fragment key={key}>
                <div className="questionnaire-item">
                  <div className="content">
                    <div className="q-date">
                      <i className="icon-event" />
                      {new Date(key).toLocaleDateString("bg-BG")}
                    </div>
                    <div className="q-row">
                      {dayEntries[key].map(entry =>
                        entry.answers.map((answer, index) => (
                          <div className="q-row-in" key={answer._id}>
                            <div className="q-row-in-content">
                              {/*   <div className="q-num">Въпрос index + 1</div>  */}

                              <div className="q-name">
                                {answer.question.text}
                              </div>

                              {this.renderAnswer(
                                answer.question.type,
                                answer.answers,
                              )}
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
      </div>
    );
  }
}

const mstp = state => ({
  dayEntries: state.user.payload.dayEntries
});

export default connect(mstp)(QuestionnaireList);



// WEBPACK FOOTER //
// ./src/components/QuestionnaireList/QuestionnaireList.js